import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";

const BASE = "/api/v1/procedures";

export const getProcedures = (params?: Record<string, any>) =>
  api.get(BASE, { params: params ? camelToSnake(params) : undefined });

export const createProcedure = (data: any) =>
  api.post(BASE, camelToSnake(data));

export const updateProcedure = (id: number, data: any) =>
  api.put(`${BASE}/${id}`, camelToSnake(data));

export const deleteProcedure = (id: number) =>
  api.delete(`${BASE}/${id}`);
